/* unplugin-vue-components disabled */import script from "./case-page.vue?vue&type=script&setup=true&lang=js"
export * from "./case-page.vue?vue&type=script&setup=true&lang=js"

import "./case-page.vue?vue&type=style&index=0&id=52b3947c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b3947c"]])

export default __exports__